import styles from '../ActivityFilters.module.scss'
import cx from 'classnames'
import { FormattedMessage } from 'react-intl'
import { isMobile } from '../../../utils'
import { useSelector } from 'react-redux'

const isDeviceMobile = isMobile()

const ToScheduleButton = () => {
  const scheduleIsShown = useSelector((state) => state.scheduleIsShown)
  if(!scheduleIsShown) {
    return null
  }
  return (
    <span
      className={styles.viewByDate}
      smooth-scroll='smooth-scroll'
      scroll-to='#schedule'
    >
      <i className='dsl-icons dsl-icons--calendar' />
      &nbsp;
      <span className={cx({ [styles.onlyMobile]: isDeviceMobile })}>
        <FormattedMessage id='view_schedule' defaultMessage='View schedule' />
      </span>
    </span>
  )
}

export default ToScheduleButton
